import axios from "axios";

const fetchStation = async stationName => {
  const response = await axios.get(`${process.env.GATSBY_PWS_API_URL}/station/${stationName}`);
  return response.data.response;
};

export { fetchStation };
